import React, { Fragment, useEffect, useState } from "react";
import { Breadcrumb } from "antd";
import cx from "classnames";
import Navbar from "../../components/newNavBar";
import Loader from "../../utils/loader";
import ItemAction from "../../components/agreementTracking/ItemAction";
import useAgreementItemActions from "../../components/agreementTracking/useAgreementItemActions";
import {
  ensureAgreementBusinessModel,
  fetchAgreementMappings,
  formatActionTakenOn,
  formatValidity,
  getBusinessModel,
} from "../../utils/agreementMapping";
import styles from "../../components/agreementTracking/agreementTracking.module.scss";
import less from "./agreementTracking.module.scss";

const AGREEMENT_COLUMNS = {
  gridTemplateColumns: "1.5fr 1.2fr 0.8fr 1.2fr 1fr 1.3fr",
};
const ITEM_COLUMNS = {
  gridTemplateColumns: "0.3fr 1.3fr 1.2fr 1.1fr 0.8fr 1.2fr 0.9fr 1.3fr",
};

// Selected keys used by the Navbar to highlight this page.
const NAV_KEYS = { MG: 11, ELECTRIC: 7.2 };

const AgreementTracking = (props) => {
  // Runs before the Navbar renders so deep links land on the right business
  // model.
  useState(ensureAgreementBusinessModel);
  const businessModel = getBusinessModel();

  const [loading, setLoading] = useState(true);
  const [agreements, setAgreements] = useState([]);

  useEffect(() => {
    if (!businessModel) {
      props.history.replace("/");
      return;
    }
    fetchAgreementMappings().then((data) => {
      setAgreements(data);
      setLoading(false);
    });
  }, [businessModel, props.history]);

  const actions = useAgreementItemActions((respondedItem, approvalStatus) => {
    setAgreements((current) =>
      current.map((agreement) => ({
        ...agreement,
        items: agreement.items.map((item) =>
          item.id === respondedItem.id
            ? { ...item, approvalStatus, actionTakenOn: new Date() }
            : item,
        ),
      })),
    );
  });

  if (loading) {
    return (
      <div className="loader">
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <Navbar selectedKey={NAV_KEYS[businessModel]} isMobile={false} />
      <div className="container">
        <div className={less.pageHeader}>
          <Breadcrumb
            items={[
              {
                title: (
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      props.history.push("/");
                    }}
                  >
                    Home
                  </a>
                ),
              },
              ...(businessModel === "MG"
                ? [{ title: "My Bus and Payments" }]
                : []),
              { title: "Agreement Tracking" },
            ]}
          />
          <h1>Agreement Tracking</h1>
        </div>

        {agreements.length === 0 ? (
          <div className={styles.emptyState}>No agreements found</div>
        ) : (
          <div className={cx(styles.table, less.table)}>
            <div
              className={cx(styles.row, styles.headerRow)}
              style={AGREEMENT_COLUMNS}
            >
              <div>Agreement Name</div>
              <div>Validity</div>
              <div>Status</div>
              <div>Action</div>
              <div>View Details</div>
              <div>Action Taken On</div>
            </div>
            {agreements.map((agreement) => (
              <Fragment key={agreement.id}>
                <div
                  className={cx(styles.row, styles.agreementRow)}
                  style={AGREEMENT_COLUMNS}
                >
                  <div>{agreement.name}</div>
                  <div>{formatValidity(agreement.validFrom, agreement.validTo)}</div>
                  <div>-</div>
                  <div>-</div>
                  <div>
                    <button
                      className={styles.viewButton}
                      onClick={() => actions.viewAgreement(agreement)}
                    >
                      View
                    </button>
                  </div>
                  <div>-</div>
                </div>
                {agreement.items.length > 0 ? (
                  <div className={styles.children}>
                    <div
                      className={cx(styles.row, styles.headerRow)}
                      style={ITEM_COLUMNS}
                    >
                      <div />
                      <div>Name</div>
                      <div>Validity</div>
                      <div>Type</div>
                      <div>Status</div>
                      <div>Action</div>
                      <div>View Details</div>
                      <div>Action Taken On</div>
                    </div>
                    {agreement.items.map((item, index) => (
                      <div
                        key={item.id}
                        className={styles.row}
                        style={ITEM_COLUMNS}
                      >
                        <div className={styles.index}>{index + 1}</div>
                        <div>{item.name}</div>
                        <div>{formatValidity(item.validFrom, item.validTill)}</div>
                        <div>{item.typeLabel}</div>
                        <div>{item.isActive ? "Active" : "Inactive"}</div>
                        <div>
                          <ItemAction item={item} actions={actions} />
                        </div>
                        <div>
                          <button
                            className={styles.viewButton}
                            onClick={() => actions.viewItem(item)}
                          >
                            View
                          </button>
                        </div>
                        <div>{formatActionTakenOn(item.actionTakenOn)}</div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </Fragment>
            ))}
          </div>
        )}
      </div>
      {actions.modals}
    </div>
  );
};

export default AgreementTracking;
